/* YEESE Size Guide Region Tabs
 * Presents Kiwi Sizing's existing region selector as direct buttons while
 * preserving Kiwi's native select, data, events, and conversion behavior.
 */
(function () {
  'use strict';

  var SELECTOR = '.kiwi-sizing-modal select.ks-i18n-conversion';
  var ORDER = ['US', 'UK', 'EU', 'DE', 'FR', 'AU'];
  var scriptElement = document.currentScript;
  var MARKET_COUNTRY = scriptElement && scriptElement.dataset.yeeseCountry
    ? scriptElement.dataset.yeeseCountry.toUpperCase()
    : '';
  var DEFAULT_REGION = MARKET_COUNTRY === 'US' ? 'US' : 'EU';
  var scanQueued = false;

  function optionLabel(option) {
    return (option.textContent || option.value || '').trim().toUpperCase();
  }

  function selectedLabel(select) {
    var option = select.options[select.selectedIndex];
    return option ? optionLabel(option) : String(select.value || '').toUpperCase();
  }

  function sync(select, control) {
    var current = selectedLabel(select);
    control.querySelectorAll('.yeese-size-region-tab').forEach(function (button) {
      var active = button.dataset.region === current;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var currentLabel = select.parentElement.querySelector('.yeese-size-region-current');
    if (currentLabel) currentLabel.textContent = current;
  }

  function enhance(select) {
    if (!select || !select.options.length) return;

    var table = select.closest('table');
    var tableWrapper = table && (table.closest('.ks-table-wrapper') || table);
    if (!tableWrapper || !tableWrapper.parentNode) return;

    var modal = select.closest('.kiwi-sizing-modal');
    if (modal && modal.dataset.yeeseMarketSizeInitialized !== 'true') {
      var marketOption = Array.prototype.slice.call(select.options).find(function (option) {
        return optionLabel(option) === DEFAULT_REGION;
      });
      modal.dataset.yeeseMarketSizeInitialized = 'true';
      if (marketOption && select.value !== marketOption.value) {
        select.value = marketOption.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var existing = tableWrapper.previousElementSibling;
    if (existing && existing.classList.contains('yeese-size-region-control')) {
      sync(select, existing);
      return;
    }

    select.classList.add('yeese-size-region-native');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;

    var current = document.createElement('span');
    current.className = 'yeese-size-region-current';
    current.setAttribute('aria-hidden', 'true');
    select.insertAdjacentElement('afterend', current);

    var control = document.createElement('div');
    control.className = 'yeese-size-region-control';

    var label = document.createElement('span');
    label.className = 'yeese-size-region-label';
    var language = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    label.textContent = language === 'de'
      ? 'Größensystem'
      : language === 'fr' ? 'Système de tailles' : 'Size System';
    control.appendChild(label);

    var tabs = document.createElement('div');
    tabs.className = 'yeese-size-region-tabs';
    tabs.setAttribute('role', 'group');
    tabs.setAttribute('aria-label', 'Size region');

    var options = Array.prototype.slice.call(select.options).sort(function (a, b) {
      var aIndex = ORDER.indexOf(optionLabel(a));
      var bIndex = ORDER.indexOf(optionLabel(b));
      return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex);
    });

    tabs.style.setProperty('--yeese-region-count', String(options.length));

    options.forEach(function (option) {
      var region = optionLabel(option);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'yeese-size-region-tab';
      button.dataset.region = region;
      button.dataset.value = option.value;
      button.textContent = region;
      button.addEventListener('click', function () {
        if (select.value === button.dataset.value) return;
        select.value = button.dataset.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync(select, control);
        window.setTimeout(scan, 50);
        window.setTimeout(scan, 250);
      });
      tabs.appendChild(button);
    });

    control.appendChild(tabs);
    tableWrapper.parentNode.insertBefore(control, tableWrapper);
    sync(select, control);
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches(SELECTOR)) queueScan();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
